
import { supabase } from "@/integrations/supabase/client";

export const createThread = async (): Promise<string> => {
  const { data, error } = await supabase.functions.invoke("openai-assistant", {
    body: { action: "createThread" }
  });
  
  if (error) throw new Error(error.message);
  return data.threadId;
};

export const addMessageToThread = async (threadId: string, content: string): Promise<void> => {
  const { error } = await supabase.functions.invoke("openai-assistant", {
    body: { action: "addMessage", threadId, query: content }
  });
  
  if (error) throw new Error(error.message);
};

export const createRun = async (threadId: string): Promise<string> => {
  const { data, error } = await supabase.functions.invoke("openai-assistant", {
    body: { action: "createRun", threadId }
  });
  
  if (error) throw new Error(error.message);
  return data.runId;
};

export const retrieveRun = async (threadId: string, runId: string) => {
  const { data, error } = await supabase.functions.invoke("openai-assistant", {
    body: { action: "retrieveRun", threadId, query: runId }
  });
  
  if (error) throw new Error(error.message);
  return data.run;
};

export const listThreadMessages = async (threadId: string) => {
  const { data, error } = await supabase.functions.invoke("openai-assistant", {
    body: { action: "listMessages", threadId }
  });
  
  if (error) throw new Error(error.message);
  return data.messages;
};
